<template>
  <div class="delivery-block">
    <header>
      <h3>Lieferadresse</h3>
      <b-button variant="primary" @click="() => selectorVisible = true">
        Wählen
      </b-button>
    </header>

    <b-form-group label="LFBIS- AMA-Klienten-Nr.:" label-cols="6">
      <b-input type="text" v-model="data.deliveryFactory.lfbis" class="text-right float-right" maxlength="8" :style="{ width: '150px' }"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Ring-Nr.:" label-cols="4">
      <b-input type="text" v-model="data.deliveryFactory.ringNr" class="text-right float-right" maxlength="4" :style="{ width: '90px' }"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Name und Anschrift.:">
      <b-textarea v-model="data.deliveryFactory.contact" rows="4"
                  :disabled="disabled || saving"/>
    </b-form-group>

    <modal-select-factory title="Foobar"
                          @cancel="() => selectorVisible = false"
                          @select="onFactorySelect"
                          v-if="selectorVisible"/>
  </div>
</template>

<script>
import {ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const data = ref(props.value)
    const selectorVisible = ref(false)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })


    const onFactorySelect = (factory) => {
      data.value.deliveryFactoryId = factory.id
      data.value.deliveryFactory = {
        lfbis: ('' + factory.businessIdentifier.lfbis).trim(),
        ringNr: factory.businessIdentifier.ringNr,
        contact: [
          factory.factoryModel.name,
          factory.factoryModel.street,
          [factory.factoryModel.placeModel.zip, factory.factoryModel.placeModel.name].join(' '),
          factory.factoryModel.countryModel.name,
        ].join("\n"),
      }
    }

    return {
      data,
      selectorVisible,
      onFactorySelect,
    }
  }
}
</script>
